export const addQueryParams = (
  url: string,
  params: Record<string, string | number>,
) => {
  const urlObj = new URL(url);

  Object.entries(params).forEach(([key, value]) => {
    urlObj.searchParams.append(key, value.toString());
  });

  return urlObj.toString();
};
